import { Outlet } from 'react-router'
import backgroundImage from '#app/components/ui/img/background_login.svg'
import logoBranco from '#app/components/ui/img/logo_jusmemoriza_branco.png'

export default function LayoutAuth() {
	return (
		<div className="flex min-h-screen flex-col bg-primary lg:flex-row">
			{/* Seção da imagem de fundo - visível apenas em desktop */}
			<div className="relative hidden lg:block lg:flex-1">
				<img
					className="absolute inset-0 h-full w-full object-cover"
					src={backgroundImage}
					alt="background login"
				/>
				<div className="flex min-h-full flex-col items-start pt-20 lg:pt-40">
					<section className="space-y-6 px-6 lg:space-y-10 lg:pl-20 lg:pr-40 xl:pl-40 xl:pr-72">
						<img
							src={logoBranco}
							className="h-24 object-contain lg:h-40"
							alt="Logo JusMemoriza"
						/>
						<h2 className="text-xl font-normal text-white lg:text-2xl">
							Estudar legislação nunca foi tão fácil.
						</h2>
					</section>
				</div>
			</div>

			{/* Logo para mobile - visível apenas em telas pequenas */}
			<div className="flex justify-center p-6 lg:hidden">
				<img
					src={logoBranco}
					className="h-20 object-contain"
					alt="Logo JusMemoriza"
				/>
			</div>

			{/* Container do conteúdo */}
			<div className="flex flex-1 flex-col justify-center rounded-t-3xl bg-card px-4 py-8 sm:px-6 lg:min-w-[600px] lg:flex-none lg:rounded-3xl lg:px-14 lg:py-12 xl:min-w-[697px] xl:px-20">
				<div className="flex h-full w-full flex-col justify-center">
					<div className="mx-auto w-full max-w-md px-0 sm:px-4 lg:px-8">
						<div className="mt-3 lg:mt-5">
							<Outlet />
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
